import React from 'react';
import styled from 'styled-components';

const F6Style = styled.svg``;

export const F6 = ({ color }) => {
	return (
		<F6Style
			xmlns='http://www.w3.org/2000/svg'
			width='24.166'
			height='21.772'
			viewBox='0 0 24.166 21.772'
		>
			<path
				id='Courthouse'
				d='M694.592,613.408a.585.585,0,0,1,0-1.171h1.024V601.658h-2.049a.978.978,0,0,1-.361-1.885l11.037-5.512a.981.981,0,0,1,.872,0h0l11.107,5.554a.974.974,0,0,1-.444,1.842H713.73v10.579h1.024a.586.586,0,1,1,0,1.171Zm2.979-11.75h0v10.579H701V601.658Zm5.385,0h0v10.579h3.436V601.658Zm5.388,0h0v10.579h3.434V601.658Zm3.317-1.951h0l-6.986-3.493-6.986,3.493Zm-18.093,16.225h0a.978.978,0,0,1,0-1.957h22.212a.978.978,0,1,1,0,1.957Z'
				transform='translate(-692.597 -594.16)'
				fill={color}
			/>
		</F6Style>
	);
};
